export type ScopeMode = 'team' | 'bedrijf';

interface ScopeToggleProps {
  scope: ScopeMode;
  onScopeChange: (scope: ScopeMode) => void;
}

export function ScopeToggle({ scope, onScopeChange }: ScopeToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50">
      <button
        type="button"
        onClick={() => onScopeChange('team')}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          scope === 'team'
            ? 'bg-white shadow-sm text-gray-900'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-pressed={scope === 'team'}
      >
        Mijn team
      </button>
      <button
        type="button"
        onClick={() => onScopeChange('bedrijf')}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          scope === 'bedrijf'
            ? 'bg-white shadow-sm text-gray-900'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-pressed={scope === 'bedrijf'}
      >
        Bedrijf
      </button>
    </div>
  );
}
